import clsx from "clsx";
import { useState } from "react";

import styles from "./collapsible.module.css";

/**
 *  @property {boolean} isInitiallyExpanded - sets default value for collapsible's state
 *  @property {boolean} toggleActiveClassOverride - display styling to active and inactive toggle item
 *  @property {boolean} shrinkCollapsibleItems - shrink items within collapsible, or instead keep size and indent from the start
 */
export type UseCollapsibleOptions = {
    isInitiallyExpanded?: boolean;
    toggledOverride?: boolean;
    shrinkCollapsibleItems?: boolean;
};

export function useCollapsible(options: UseCollapsibleOptions = { shrinkCollapsibleItems: false }) {
    const { isInitiallyExpanded, toggledOverride, shrinkCollapsibleItems } = options;

    const [isCollapsibleExpanded, setCollapsibleIsExpanded] = useState(isInitiallyExpanded ?? false);

    const createCollapsibleToggleProps = () => {
        const isActive = toggledOverride ?? isCollapsibleExpanded;
        return {
            onClick: () => setCollapsibleIsExpanded((expanded) => !expanded),
            className: styles.collapsible_toggle,
            "data-collapsible-toggled": String(isActive),
        };
    };

    const createCollapsibleProps = () => {
        return {
            isCollapsibleExpanded,
            className: clsx({ [styles.collapsible_indented_initially]: !shrinkCollapsibleItems }),
        };
    };

    const createCollapsibleItemProps = () => {
        return {
            className: clsx({ [styles.collapsible_item]: shrinkCollapsibleItems }),
        };
    };

    return { isCollapsibleExpanded, createCollapsibleProps, createCollapsibleToggleProps, createCollapsibleItemProps };
}
